import Glide from '@glidejs/glide';

export const RPMRotator = (function () {
	'use strict';
 
	let rpmCarousels;

	function init() {
		rpmCarousels = document.querySelectorAll('.glide');
		if (rpmCarousels.length > 0) {
			rpmCarousels.forEach( rpmCarousel => {
				renderRPMCarousel(rpmCarousel);
			});
		}
	}

	function renderRPMCarousel(carousel) {
		let rpmCarousel = new Glide(carousel, {
			type: 'carousel',
			perView: 1,
			autoplay: true,
			hoverpause: false,
		});

  		rpmCarousel.mount();

	}

	return {
		init: init,
	};
})();
